$(function () {

    $(document).ready(() => {
        var obj = $('.print-btn');
        if (obj[0]) {
            obj[0].addEventListener('click', () => {

                window.dispatchEvent(new CustomEvent('beforeprint'));

                $('.detail-view__content').printThis({
                    debug: false,               // show the iframe for debugging
                    importCSS: false,            // import parent page css
                    importStyle: false,          // import style tags
                    printContainer: false,      // print outer container/$.selector
                    loadCSS: "static/scss/media/print.css",                // path to additional css file - use an array [] for multiple
                    pageTitle: "",              // add title to print page
                    removeInline: false,        // remove inline styles from print elements
                    removeInlineSelector: "*",  // custom selectors to filter inline styles. removeInline must be true
                    printDelay: 1000,           // variable print delay
                    header: null,               // prefix to html
                    footer: null,               // postfix to html
                    base: false,                // preserve the BASE tag or accept a string for the URL
                    formValues: true,           // preserve input/form values
                    canvas: false,              // copy canvas content
                    doctypeString: '',          // enter a different doctype for older markup
                    removeScripts: false,       // remove script tags from print content
                    copyTagClasses: false,      // copy classes from the html & body tag
                    beforePrintEvent: null,     // function for printEvent in iframe
                    beforePrint: null,          // function called before iframe is filled
                    afterPrint: null            // function called before iframe is removed
                });
            });
        }

    });
});



// WEBPACK FOOTER //
// ./static/js/modules/print-this.js